import React from "react";
import PostsList from "../posts/PostsList";

const App_posts = () => {
 return (
  <div className="bigcontainer">
   <PostsList />
  </div>
 );
};

export default App_posts;
